import { DeleteMode } from "PFApp/booking/components/delete_booking_modal/delete_booking.types";

export const getDeleteMode = (activityId: number | null, activitySiblingsCount: number): DeleteMode => {
  if (!activityId) {
    return DeleteMode.NoActivityBooking;
  }
  if (activitySiblingsCount > 0) {
    return DeleteMode.MultipleBookings;
  }
  return DeleteMode.LastBooking;
};
